<template>
  <!-- Contractor Edit -->
  <b-modal
    id="modalEdit"
    title="แก้ไขข้อมูลผู้รับจ้าง"
    size="1.714rem"
    ok-title="ตกลง"
    cancel-title="ยกเลิก"
    @ok="editInfo"
  >
    <b-row>
      <!-- Name Company -->
      <b-col cols="12">
        <b-form-group
          label="ชื่อบริษัท"
          label-for="Namecompany"
        >
          <b-input-group class="input-group-merge">
            <b-form-input
              id="vendor_name"
              v-model="editData.vendor_name"
              type="text"
              placeholder="ชื่อบริษัท"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group
          label="ที่อยู่"
          label-for="address"
        >
          <b-input-group class="input-group-merge">
            <!-- <b-input-group-prepend is-text>
                    <feather-icon icon="MailIcon" />
                  </b-input-group-prepend> -->
            <textarea
              id="vendor_address"
              v-model="editData.vendor_address"
              style="background-color: rgba(0, 0, 0, 0); color: #fff; width: 100%; height: 80px; border-radius: 5px; border-color: #404656;"
              type="text"
              placeholder="ที่อยู่"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <!-- NAME -->
      <b-col cols="12">
        <b-form-group
          label="ชื่อ-นามสกุล"
          label-for="name"
        >
          <b-input-group class="input-group-merge">
            <!-- <b-input-group-prepend is-text>
                    <feather-icon icon="MailIcon" />
                  </b-input-group-prepend> -->
            <b-input-group-prepend is-text>
              <feather-icon icon="UserIcon" />
            </b-input-group-prepend>
            <b-form-input
              id="vendor_contact_name"
              v-model="editData.vendor_contact_name"
              type="text"
              placeholder="ชื่อ-นามสกุล"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <!-- Tel -->
      <b-col cols="12">
        <b-form-group
          label="เบอร์โทร"
          label-for="tel"
        >
          <b-input-group class="input-group-merge">
            <!-- <b-input-group-prepend is-text>
                    <feather-icon icon="MailIcon" />
                  </b-input-group-prepend> -->
            <b-form-input
              id="vendor_contact_tel"
              v-model="editData.vendor_contact_tel"
              type="text"
              placeholder="เบอร์โทร"
              maxlength="12"
              @input="acceptNumber"
              @keyup.delete="console.log(1)"
              @keypress="isLetter2($event)"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <!-- English abbreviations -->
      <b-col cols="12">
        <b-form-group
          label="ชื่อย่อภาษาอังกฤษบริษัท / ชื่อผู้ใช้งาน"
          label-for="englishabbreviations"
        >
          <b-input-group class="input-group-merge">
            <!-- <b-input-group-prepend is-text>
                    <feather-icon icon="MailIcon" />
                  </b-input-group-prepend> -->
            <b-form-input
              id="vendor_shortname_english"
              v-model="editData.vendor_shortname_english"
              type="text"
              placeholder="ภาษาอังกฤษเท่านั้น ไม่เกิน 5 ตัวอักษร (ชื่อผู้ใช้งาน)"
              maxlength="5"
              @keyup.delete="console.log(1)"
              @keypress="isLetter($event)"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <!-- Role -->
      <!-- <b-col
        cols="12"
        class="hidden"
      >
        <b-form-group
          label="สถานะ"
          label-for="role"
        >
          <v-select
            v-model="editData.role"
            :reduce="role => role.role"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="role"
            :options="role"
            transition=""
            disabled
          />
        </b-form-group>
      </b-col> -->

      <!-- DEPARTMENT -->
      <!-- <b-col
        cols="12"
        class="hidden"
      >
        <b-form-group
          label="หน่วยงาน"
          label-for="department"
        >
          <v-select
            v-model="editData.department"
            :reduce="department => department.DeptID"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="deptname"
            :options="department"
            transition=""
            disabled
          />
        </b-form-group>
      </b-col> -->

      <!-- <template #code>
        {{ codeFeedbackHelper }}
      </template> -->
    </b-row>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BFormGroup, BInputGroup, BFormInput, BInputGroupPrepend,
} from 'bootstrap-vue'
// import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BInputGroup,
    BFormInput,
    // vSelect,
    BInputGroupPrepend,
  },
  data() {
    return {
      role: [],
      department: [],
      editData: {
        vendor_id: '',
        vendor_name: '',
        vendor_shortname_english: '',
        vendor_address: '',
        vendor_contact_name: '',
        vendor_contact_tel: '',
        role: '',
        department: '',
      },
      selectedUser: '',
    }
  },
  mounted() {
    this.dropdownVendorRole()
    this.dropdownDepartment()
  },
  methods: {
    // ดึงข้อมูลผู้ใช้มาแก้ไขในModal
    sendInfo(id) {
      this.selectedUser = id
      console.log(id)
      axios
        .post('/fetchVendor', { vendor_id: this.selectedUser })
        .then(response => {
          console.log(response)
          this.editData.vendor_name = response.data.vendor_name
          this.editData.vendor_shortname_english = response.data.vendor_shortname_english
          this.editData.vendor_address = response.data.vendor_address
          this.editData.vendor_contact_name = response.data.vendor_contact_name
          this.editData.vendor_contact_tel = response.data.vendor_contact_tel
          this.editData.role = response.data.role
          this.editData.department = response.data.department
          this.editData.vendor_id = this.selectedUser
          this.dropdownVendorRole()
          this.dropdownDepartment()
        })
        .catch(error => {
          console.log(error)
        })
    },
    // แก้ไขข้อมูลผู้ใช้ในModal
    async editInfo() {
      const display = this.editData
      axios
        .post('/editVendor', display)
        .then(response => {
          console.log(response)
          this.$swal({
            icon: 'success',
            title: '<span style="color:#000000">แก้ไขข้อมูลเรียบร้อย.</span>',
            showConfirmButton: false,
            timer: 1000,
          })
          this.$emit('fetch')
        })
        .catch(error => {
          console.log(error)
        })
    },
    dropdownVendorRole() {
      axios
        .post('/dropdownRole')
        .then(response => {
          this.role = response.data
        })
    },
    dropdownDepartment() {
      axios
        .post('/dropdownDepartment')
        .then(response => {
          this.department = response.data
        })
    },

    // ------------------- พิมพ์ได้แต่ภาษาอังกฤษ ------------------
    // eslint-disable-next-line consistent-return
    isLetter(e) {
      const char = String.fromCharCode(e.keyCode)
      if (/^[A-Za-z]+$/.test(char)) return true
      e.preventDefault()
    },

    // ------------------- ใส่ขีด(-)ตัวเลขเบอร์โทร ------------------
    acceptNumber() {
      const x = this.editData.vendor_contact_tel.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
      this.editData.vendor_contact_tel = !x[2] ? x[1] : `${x[1]}-${x[2]}${x[3] ? `-${x[3]}` : ''}`
    },

    // ------------------- พิมพ์ได้แต่ตัวเลข ------------------
    // eslint-disable-next-line consistent-return
    isLetter2(e) {
      const char = String.fromCharCode(e.keyCode)
      if (/^[0-9]+$/.test(char)) return true
      e.preventDefault()
    },
  },
}
</script>
